import { Directive, HostBinding, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { DECIMAL_ERROR, DecimalValidationError } from '@app/validators/decimal.validators';

@Directive({
  standalone: true,
  selector: 'mat-error[appDecimalError]',
})
export class DecimalErrorDirective {
  @Input() public appDecimalError: AbstractControl | null | undefined;

  @HostBinding('textContent')
  protected get errorMessage(): string {
    return this.decimalErrorMessage ?? '';
  }

  @HostBinding('style.display')
  protected get displayStyle(): string {
    return this.decimalErrorMessage ? '' : 'none';
  }

  private get decimalErrorMessage(): string | null {
    const error = this.appDecimalError?.getError(DECIMAL_ERROR) as DecimalValidationError | undefined;

    return error?.message ?? null;
  }
}
